import { render, staticRenderFns } from "./SendFromBlock.vue?vue&type=template&id=c792b976&scoped=true"
import script from "./SendFromBlock.vue?vue&type=script&lang=js"
export * from "./SendFromBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c792b976",
  null
  
)

export default component.exports